import unlockAccount from 'pages/Users/utils/unlockAccount'
import { useEffect } from 'react'

interface useInitCentersProps {
  getRows: Function
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
  unlockAccount: Function
}

const useInit = (props: useInitCentersProps) => {
  useEffect(() => {
    props
      .getRows({
        setDeleteEntryId: props.setDeleteEntryId,
        setShowModal: props.setShowModal,
        unlockAccount: props.unlockAccount,
      })
      .then((data: any) => {
        props.setRows(data)
        props.setShowOverlay(false)
      })
  }, [])
}

export default useInit
